export default __webpack_public_path__ + "2ded0bf485e7ca05264a15b4ed1d2849.svg";